<header class="contract-history__header">
	<div>
		<h2 mat-dialog-title>Histórico de alterações</h2>
		<p>{{ data.contract.displayName || data.contract.name }}</p>
	</div>
	<button
		mat-icon-button
		type="button"
		mat-dialog-close
		aria-label="Fechar histórico"
	>
		<mat-icon>close</mat-icon>
	</button>
</header>

<mat-dialog-content class="contract-history__content">
	<section class="contract-history__timeline" aria-label="Versões do contrato">
		<div
			class="contract-history__state"
			*ngIf="isLoadingHistory && !items.length"
		>
			<mat-spinner diameter="24"></mat-spinner>
			<span>Carregando histórico...</span>
		</div>

		<div
			class="contract-history__state"
			*ngIf="historyError && !items.length"
			role="alert"
		>
			<span>Não foi possível carregar o histórico.</span>
			<button mat-stroked-button type="button" (click)="loadHistory(true)">
				Tentar novamente
			</button>
		</div>

		<p
			class="contract-history__state"
			*ngIf="!isLoadingHistory && !historyError && !items.length"
		>
			Nenhuma alteração registrada pela Sanus.
		</p>

		<ol class="contract-history__list" *ngIf="items.length">
			<li *ngFor="let version of items; trackBy: trackByVersionId">
				<button
					type="button"
					class="contract-history__version"
					[class.contract-history__version--selected]="
						selectedVersionId === version.id
					"
					[attr.aria-current]="selectedVersionId === version.id ? 'true' : null"
					(click)="selectVersion(version)"
				>
					<span class="contract-history__marker"></span>
					<span class="contract-history__version-copy">
						<strong>Versão {{ version.versionNumber }}</strong>
						<span>{{ actionLabel(version.action) }}</span>
						<small>
							{{ version.changedBy.name }} ·
							{{ version.createdAt | date: 'dd/MM/yyyy HH:mm' }}
						</small>
						<small *ngIf="version.attachment">
							<mat-icon>attach_file</mat-icon>
							{{ version.attachment.name }}
						</small>
					</span>
					<mat-icon aria-hidden="true">chevron_right</mat-icon>
				</button>
			</li>
		</ol>

		<button
			mat-stroked-button
			type="button"
			class="contract-history__load-more"
			*ngIf="canLoadMore"
			[disabled]="isLoadingHistory"
			(click)="loadHistory()"
		>
			{{ isLoadingHistory ? 'Carregando...' : 'Carregar mais' }}
		</button>
		<p
			class="contract-history__inline-error"
			*ngIf="historyError && items.length"
			role="alert"
		>
			Não foi possível carregar mais versões.
			<button mat-button type="button" (click)="loadHistory()">
				Tentar novamente
			</button>
		</p>
	</section>

	<section class="contract-history__detail" aria-label="Comparação da versão">
		<div class="contract-history__state" *ngIf="isLoadingDetail">
			<mat-spinner diameter="24"></mat-spinner>
			<span>Carregando comparação...</span>
		</div>

		<div class="contract-history__state" *ngIf="detailError" role="alert">
			<span>Não foi possível carregar os detalhes desta versão.</span>
			<button mat-stroked-button type="button" (click)="retryDetail()">
				Tentar novamente
			</button>
		</div>

		<p
			class="contract-history__state"
			*ngIf="!selectedVersionId && !isLoadingDetail"
		>
			Selecione uma versão para visualizar as alterações.
		</p>

		<ng-container *ngIf="detail">
			<div class="contract-history__detail-header">
				<div>
					<h3>Versão {{ detail.versionNumber }}</h3>
					<p>
						{{ actionLabel(detail.action) }} por
						<strong>{{ detail.changedBy.name }}</strong>
					</p>
					<small>{{ detail.createdAt | date: 'dd/MM/yyyy HH:mm' }}</small>
				</div>
				<span class="contract-history__attachment" *ngIf="detail.attachment">
					<mat-icon class="contract-history__attachment-icon">
						attach_file
					</mat-icon>
					{{ detail.attachment.name }}
				</span>
			</div>

			<div class="contract-history__legend" aria-label="Legenda da comparação">
				<span
					class="contract-history__legend-item contract-history__legend-item--added"
				>
					Adicionada
				</span>
				<span
					class="contract-history__legend-item contract-history__legend-item--removed"
				>
					Removida
				</span>
				<span
					class="contract-history__legend-item contract-history__legend-item--unchanged"
				>
					Sem alteração
				</span>
			</div>

			<div class="contract-history__diff" aria-label="Diferenças por linha">
				<div
					*ngFor="let block of detail.diff"
					class="contract-history__diff-block"
					[class.contract-history__diff-block--added]="block.type === 'added'"
					[class.contract-history__diff-block--removed]="
						block.type === 'removed'
					"
					[class.contract-history__diff-block--unchanged]="
						block.type === 'unchanged'
					"
				>
					<span class="contract-history__diff-label">
						{{ diffLabel(block.type) }}
					</span>
					<pre>{{ block.lines.join('\n') }}</pre>
				</div>
			</div>
		</ng-container>
	</section>
</mat-dialog-content>
